<div class="mat-dialog-draggable-main-content mat-dialog-signature-process">
    <div class="mat-dialog-draggable-header">
      <h2 mat-dialog-title mat-dialog-draggable-title>{{'title.re_choose_signature_process' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider style="padding-bottom: 1rem;"></mat-divider>
    </div>
    <mat-dialog-content>
      <div *ngIf="initialInfo">
        <p [innerHTML]="currentInitialText"></p>
        <mat-card class="example-card" style="padding-left: 20px !important;">
          <mat-card-header>
            <mat-card-title style="color: #3866DE; font-size: 16px">{{initialInfo.name}}</mat-card-title>
            <mat-card-subtitle style="color: #ACB8E6;">{{initialInfo.email}} - {{initialInfo.phone}} <span *ngIf="initialInfo.userPosition">- {{initialInfo.userPosition}}</span></mat-card-subtitle>
          </mat-card-header>
        </mat-card>
        <mat-divider style="padding-bottom: 1rem;"></mat-divider>
      </div>
      <div class="popup-content">
        <label>{{'re_submit_sign_confirmation.label' | translate}}:</label>
        <nz-input-group [nzSuffix]="suffixUserInput">
          <input nz-input [(ngModel)]="inputUserValue" (input)="onChangeUserSignSearch($event.target.value)"
                 [nzAutocomplete]="autoUserSearching" [ngModelOptions]="{ standalone: true }"
                 placeholder="{{'placeholder.name_email_and_posiotion' | translate}}"/>
          <nz-autocomplete #autoUserSearching>
            <nz-auto-option *ngFor="let user of filteredUserOptions"
                            (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">{{user.name}}
              - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option>
          </nz-autocomplete>
        </nz-input-group>
        <ng-template #suffixUserInput>
          <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
        </ng-template>
        <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                            style="font-size: 24px;"></i></ng-template>
      </div>

      <div *ngIf="newInitialInfo">
        <p style="margin-top: 10px;">{{ 're_submit_sign_confirmation.new_initial_info' | translate }}:</p>
        <mat-card class="example-card" style="padding-left: 20px !important;">
          <mat-card-header>
            <mat-card-title style="font-size: 16px">{{newInitialInfo.name}}</mat-card-title>
            <mat-card-subtitle>{{newInitialInfo.email}} - {{newInitialInfo.phone}} <span *ngIf="newInitialInfo.userPosition">- {{newInitialInfo.userPosition}}</span></mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
  
    </mat-dialog-content>
    <div class="w-100 mat-dialog-draggable-footer">
      <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button [disabled]="!isFormChanging" (click)="onClickBtnConfirm()"
                type="button" color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'confirm'| translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
  
  
  